import { render, staticRenderFns } from "./RichModal.vue?vue&type=template&id=1e77dc4f&scoped=true&"
import script from "./RichModal.vue?vue&type=script&lang=js&"
export * from "./RichModal.vue?vue&type=script&lang=js&"
import style0 from "./RichModal.vue?vue&type=style&index=0&id=1e77dc4f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e77dc4f",
  null
  
)

export default component.exports